// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import {Component, Inject, OnInit} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';

export interface ICustomSnackBarConfig {
  message: string;
  action?: string;
}

@Component({
    selector: 'app-custom-snack-bar',
    templateUrl: './custom-snack-bar.component.html',
    styleUrls: ['./custom-snack-bar.component.scss'],
    standalone: false
})
export class CustomSnackBarComponent implements OnInit {
  constructor(
      private snackBarRef: MatSnackBarRef<CustomSnackBarComponent>,
      @Inject(MAT_SNACK_BAR_DATA) public config: ICustomSnackBarConfig,
  ) { }

  ngOnInit(): void {
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
